(function(){

	puremvc.define
	(
		// CLASS INFO
		{
			name: 'sinewav3.controller.command.startup.PrepareModelCommand',
			parent: puremvc.SimpleCommand
		},

		// INSTANCE MEMBERS
		{
			execute: function (note)
			{
				console.log("PrepareModelCommand: Preparing the Model");

				// TODO: Register ONLY long-lived proxies that don't need to be destroyed between reuses

			}
		}
	);

})();
